import { useFormik, Form, FormikProvider } from "formik";
import { useSelector } from "react-redux";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { createDocument } from "apis/customApiHandler";
import { updateDocumentByID } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import axios from "axios";

const Edit = ({ data, handleClick }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      price: data.price || 0,
      twcIssueId: data._id,
    },
    onSubmit: async (values) => {
      axios({
        url: "twcRoutes/updateTwcIssue",
        method: "PUT",
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
        params: {
          twcIssueId: data._id,
        },
        data: values,
        baseURL: `${process.env.REACT_APP_API_URL}`,
      })
        .then((res) => {
          toast.success("Successfully saved");
          queryClient.invalidateQueries("/getTWCIssues");
        })
        .catch((err) => {
          toast.error(err.response.data);
        });
      handleClick();
    },

    validate: (values) => {
      let errors = {};
      if (!values.price) errors.price = "Required";
      return errors;
    },
  });

  return (
    <Model
      handleClick={handleClick}
      title={"Edit TWC Issue"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <InputField type="text" label="Price" name="price" required={true} />
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="submit" bgPrimary onClick={formik.onSubmit}>
              Save Changes
            </Button>
          </div>
        </Form>
      </FormikProvider>
    </Model>
  );
};

export default Edit;
